import Nav from "./nav"
import Search from "./search"
import Tablesort from "./tablesort"
import BeforeAfter from "./before-after"
import HoverEffect from "./link-hover-large"
import Share from "./share"
import Sliders from "./sliders"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Search(jQuery)
    Tablesort(jQuery)
    BeforeAfter(jQuery)
    HoverEffect(jQuery)
    Share(jQuery)
    Sliders(jQuery)
})
